import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"

const SustainLanding = ({ title, image, video }) => {
  return (
    <section className="sustain-landing">
      <div className="sustain-landing__inner">
        <div className="sustain-landing__media">
          {video && <video src={video} autoPlay loop muted playsInline />}
          {image && !video && <Asset asset={image} />}
        </div>

        {title && (
          <div
            className="sustain-landing__title"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-easing="ease"
          >
            <h1>{parse(title)}</h1>
          </div>
        )}
      </div>
    </section>
  )
}

export default SustainLanding

export const query = graphql`
  fragment SustainLandingProps on DatoCmsSustainLanding {
    ... on DatoCmsSustainLanding {
      id
      title
      video
      image {
        ...InternalAssetProps
      }
    }
  }
`
